import * as IoC from 'inversify';
import { registerCommand } from '@/app/tracking/api';
import { CompleteExamTrackingCommandName, QueryExamResultsTrackingQueryName } from '../api'
import { XApiCompleteExamCommandHandler } from './xapi-complete-exam-command-handler'
import { registerQuery } from '@/app/tracking/common';
import { examCommonTrackingModule } from '../common/di'
import { XApiQueryExamResultsQueryHandler } from './xapi-query-exam-results-query-handler';

export const examTinCanTrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(CompleteExamTrackingCommandName, XApiCompleteExamCommandHandler, bind);
  registerQuery(QueryExamResultsTrackingQueryName, XApiQueryExamResultsQueryHandler, bind);
})

export const examTinCanTrackingModules = [
  examCommonTrackingModule,
  examTinCanTrackingModule
]
